import script from "./ButtonsListConfigButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ButtonsListConfigButton.vue?vue&type=script&lang=ts&setup=true"

import "./ButtonsListConfigButton.vue?vue&type=style&index=0&id=661a436e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-661a436e"]])

export default __exports__